import React, { Component } from 'react';
import rootRoutes from './components/web/rootRoutes';
import NotFound from './NotFound';
import { Switch, Route, BrowserRouter } from 'react-router-dom';
import { NotificationContainer } from "react-notifications";
import "react-notifications/lib/notifications.css";
import { Provider } from 'react-redux';
import store from './store';
import ScrollToTopButton from './utils/Scroll-to-top-button';
import TicketChatWidget from './utils/TicketChatWidget';
import FloatingViewerButton from "./utils/FloatingViewerButton";
export default class App extends Component {
	render() {
		return (
			<Provider store={store}>
				<div className="App">
					<NotificationContainer />
					<BrowserRouter>
						<Switch>
							<Route path='/' component={rootRoutes} />
							<Route component={NotFound} />
						</Switch>
						{/* <TicketChatWidget />   */}
						{/* <FloatingViewerButton /> */}
					</BrowserRouter>
					<ScrollToTopButton />
				</div>
			</Provider>
		);
	}
}
